import { Put } from "services";

export const updateEatAppRoomsMapping = async ({ venueId, roomsMapping }) => {
  return Put(`inventory/integration/eat-app/venue/${venueId}/configuration`, {
    roomsMapping,
  });
};
